import {gsap} from "gsap";


const animationOnce = (container) => {
     // console.log("SinglePost animation ONCE");

    // Element à animer
    const mask = container.querySelector("#project_image_mask");
    const animation_square_circle = container.querySelector("#anim_square_circle");

    gsap.set(container, {alpha:1})
    gsap.set(mask, {width:'100%'})
    gsap.set(animation_square_circle, {top:"random(60,300)", right:"random(80,310)"})
    gsap.set("#primary_section, #secondary_section", {alpha:0, y:'20px'})
    // document.body.classList.add("apply-single-post");

    document.body.classList.add("apply-single-post")

    console.log(mask);


    // Gsap timeline
    const tl = gsap.timeline({
        defaults : {
            //duration: 1,
            ease: "power1.out",
        },
        paused:false,
        delay:0,
    });
    tl.set('body', {backgroundColor:'#FFFFFF'});
    tl.to(mask, {width:0,ease: "power2.out", duration:1});
     tl.to("#primary_section, #secondary_section", {alpha:1, y:0}, '-=.7');
    // tl.to(mask, {width:'100%'});
    // tl.to(container, {alpha:1})


    //pour dev
    tl.timeScale( 1.5 );
    return tl;
}

export default animationOnce;
